import { getCloudinaryStaticBaseUrl } from "../config/cloudinaryBase";

const cloudinaryStaticBase = getCloudinaryStaticBaseUrl();

/**
 * An object containing various regular expressions for common validation purposes.
 * @property {string} BASE_URL - The base URL for the application.
 * @property {object} REGEX - An object containing various regular expressions.
 *   @property {RegExp} EMAIL - Regular expression for validating email addresses.
 *   @property {RegExp} SPECIALCHARACTERS - Regular expression for finding special characters in a string.
 *   @property {RegExp} NUMBER - Regular expression for finding numbers in a string.
 *   @property {RegExp} NAME - Regular expression for validating names.
 *   @property {RegExp} ALPHABETCOMMA - Regular expression for validating strings with alphabets, numbers, and commas.
 *   @property {RegExp} ADDRESS - Regular expression for validating addresses.
 */
const Constant = {
  MAP_KEY: process.env.GOOGLE_MAP_API_KEY,
  BASE_URL: process.env.REACT_APP_BASE_URL,
  REGEX: {
    EMAIL: /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/,
    SPECIALCHARACTERS: /[!@#$%^&*)(+=._-]/g,
    NUMBER: /[0-9]/,
    NUMBER1TO9: /[1-9]/,
    NAME: /^[a-zA-Z.'\-\u00C0-\u02AF ]+$/,
    ALPHABETCOMMA: /^[ a-zA-Z0-9.]+$/i,
    ADDRESS: /^[a-zA-Z0-9\s.,#-]+$/,
    ALPHANUMERIC: /^[a-zA-Z0-9\s\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F]+$/i,
    LOWERCASEUPPERCASE: /[a-z].*[A-Z]|[A-Z].*[a-z]/,
    NUMERIC: /^\d*\.?\d*$/,
    NUMONLY: /^\d*$/,
    QUANTITY: /^[0-9]{8}$/,
    PERCENTAGE: /^(100(\.0{1,2})?|[1-9]?\d(\.\d{1,2})?)$/,
    POSITIVENUMBERS: /^[0-9]\d*(\.\d+)?$/,
    URL: /^(?:(?:https?:\/\/)?(?:docs\.google\.com\/document\/d\/[A-Za-z0-9_-]+\/edit)).*$/i,
    /** Full http(s) URL — not bare usernames or @handles. */
    HTTP_URL: /^https?:\/\/.+/i,
    LOWERCASE: /[a-z]/,
    UPPERCASE: /[A-Z]/,
    SPECIALCHARSREGEX: /^[a-zA-Z0-9!@#$%^&*()_+{}[\]:;<>,.?\\/~`|-]+$/,
    PAYNUMBER: /^\d{5}$/,
    // ALPHANUMERICSPECIALCHAR : /^[a-zA-Z0-9\s!@#$%^&*()_+\-=[\]{};:'",<.>/?\\|£]+$/i
    ALPHANUMERICSPECIALCHAR: /^[\s\S]+$/i,
    AMOUNT: /^\d{1,5}(\.\d{1,2})?$/,
    PARENTAMOUNT: /^\d*\.?\d*$/,
  },

  SESSIONSTORAGEKEYS: {
    REMEMBER_ME: "Rizztix_rememberMe",
    RIZZTIX_REMEMBER_ME_EMAIL: "Rizztix_rememberMe_email",
    RIZZTIX_REMEMBER_ME_PASSWORD: "Rizztix_rememberMe_password",
    OTP: "otp",
    RESENDOTP: "resendOtp",
    OTP_REQUEST_ID: "otpRequestId",
    EVENTS_OTP_VERIFIED: "eventsOtpVerified",
    FORGOT_EMAIL: "forgotEmail",
    RESET_TOKEN: "resetToken",
    RESET_PASS: "resetPass",
    USER_NAME: "fullname",
    USER_IMAGE: "image",
    ID: "id",
    /** After login, navigate here (full path + query, e.g. /my-tickets/id?token=...) */
    MY_TICKETS_REDIRECT: "myTicketsRedirect",
  },
  LOCALSTORAGEKEYS: {
    ACCESSTOKEN: "accessToken",
    REFRESHTOKEN: "refreshToken",
    /** Persisted on login for CLUB_MANAGER when JWT omits club claims (backend-dependent). */
    MANAGED_CLUB_ID: "managedClubId",
    /** Staff reference code for CLUB_EMPLOYEE (from login user or employees list). */
    EMPREF: "empref",
  },
  GENERALKEYS: {
    INACTIVE: "deactive",
    ACTIVE: "active",
    PAID: "Paid",
    PENDING: "Pending",
    FAIL: "Fail",
    CANCELLED: "Cancelled",
    REFUNDED: "Refunded",
    ONGOING: "Ongoing",
    UPCOMING: "Upcoming",
    CANCEL: "Cancel",
    COMPELETED: "Completed",
    INVITE_SENT: "Invite sent",
  },
  ROLES: {
    USER: "USER",
    ORGANISER: "ORGANISER",
    ADMIN: "ADMIN",
    CLUB_MANAGER: "CLUB_MANAGER",
    CLUB_EMPLOYEE: "CLUB_EMPLOYEE",
    CLUB_OPERATOR: "CLUB_OPERATOR",
    ALL: "ALL",
    GUEST: "GUEST",
  },
  NODATAIMAGE_URL: {
    USER: `${cloudinaryStaticBase}user.png`,
    ORGANISER: `${cloudinaryStaticBase}organiser.png`,
    TICKET: `${cloudinaryStaticBase}ticket.png`,
    EVENTS: `${cloudinaryStaticBase}events.png`,
    CATEGORIES: `${cloudinaryStaticBase}categories.png`,
    ARTIST: `${cloudinaryStaticBase}artist.png`,
    NOTIFICATION: `${cloudinaryStaticBase}notification.png`,
    ERROR_IMAGE: `${cloudinaryStaticBase}404_error.svg`,
  },
};
export default Constant;
